import { updateBodyClasses } from './userRole';

const AUTH_TOKEN_KEY = 'auth_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

const TEAM_SCOPED_KEYS = [
  'selected_team_id',
  'selected_team_name',
  'selected_team_type',
  'selected_team_age_group',
  'selected_team_league',
  'selected_team_has_waitinglist',
  'selected_team_has_max_players',
  'selected_team_has_training',
  'selected_team_hide_leaderboard',
  'selected_team_hide_wins_draws_losses',
  'selected_team_hide_player_ratings',
  'selected_team_kit_colour',
  'permanent_keeper',
  'training_sessions',
  'superadmin_viewing_as_player',
  'welcome_modal_dismissed',
  'pro_return_url',
  'pro_team_name',
  'child_name',
];

function refreshBodyClasses() {
  if (typeof window.updateBodyClasses === 'function') {
    window.updateBodyClasses();
  } else {
    updateBodyClasses();
  }
}

export function clearTeamScopedSession() {
  TEAM_SCOPED_KEYS.forEach((key) => sessionStorage.removeItem(key));
}

export function clearSessionState() {
  sessionStorage.clear();
  refreshBodyClasses();
}

export function clearAuthTokens() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

export function applyIdentityFromLoginResult(result, { phone } = {}) {
  if (!result || !result.user_id) {
    return;
  }

  sessionStorage.setItem('user_id', String(result.user_id));
  sessionStorage.setItem('first_name', result.first_name || '');
  sessionStorage.setItem('last_name', result.last_name || '');
  sessionStorage.setItem('user_type', result.user_type || 'player');

  if (phone) {
    sessionStorage.setItem('phone', phone);
  } else if (result.phone) {
    sessionStorage.setItem('phone', result.phone);
  }

  if (result.is_child !== undefined) {
    sessionStorage.setItem('is_child', result.is_child ? 'true' : 'false');
  }
  if (result.can_respond_to_availability !== undefined) {
    sessionStorage.setItem(
      'can_respond_to_availability',
      result.can_respond_to_availability ? 'true' : 'false'
    );
  }

  const userType = result.user_type || 'player';

  if (userType === 'player') {
    sessionStorage.setItem('player_id', String(result.user_id));
    if (result.shirt_number !== undefined && result.shirt_number !== null) {
      sessionStorage.setItem('shirt_number', result.shirt_number);
    }
    sessionStorage.setItem('is_first_login', result.is_first_login ? 'true' : 'false');
    if (result.previous_last_login) {
      sessionStorage.setItem('previous_last_login', result.previous_last_login);
    }
    sessionStorage.setItem('is_manager', result.is_manager ? 'true' : 'false');
    sessionStorage.setItem('is_parent', 'false');
  } else if (userType === 'parent') {
    sessionStorage.setItem('is_parent', 'true');
    sessionStorage.setItem('is_manager', 'false');
    sessionStorage.setItem('is_first_login', result.is_first_login ? 'true' : 'false');
    if (result.children && result.children.length > 0) {
      sessionStorage.setItem('has_children', 'true');
      const firstChild = result.children[0];
      if (firstChild.first_name && firstChild.last_name) {
        sessionStorage.setItem('child_name', `${firstChild.first_name} ${firstChild.last_name}`);
      }
    } else {
      sessionStorage.setItem('has_children', 'false');
    }
  } else if (userType === 'manager' || userType === 'coach') {
    sessionStorage.setItem('is_manager', 'true');
    sessionStorage.setItem('is_parent', 'false');
    if (result.manager_type) {
      sessionStorage.setItem('manager_type', result.manager_type);
    }
    sessionStorage.setItem('is_player_manager', result.is_player_manager ? 'true' : 'false');
    sessionStorage.setItem('is_first_login', result.is_first_login ? 'true' : 'false');
    if (result.previous_last_login) {
      sessionStorage.setItem('previous_last_login', result.previous_last_login);
    }
    if (result.is_player_manager && result.player_id) {
      sessionStorage.setItem('player_id', String(result.player_id));
    }
  }

  if (result.is_admin !== undefined) {
    sessionStorage.setItem('is_admin', result.is_admin ? 'true' : 'false');
  }

  refreshBodyClasses();
}

export function logoutAndRedirect() {
  sessionStorage.clear();
  clearAuthTokens();

  document.cookie.split(';').forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, '')
      .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
  });

  window.location.href = '/';
}

export function hardNavigate(path) {
  window.location.assign(path);
}
